// Config for the "Learn machine learning" landing page at /machine-learning —
// edit these values per campaign, no other code changes needed. Used by
// MachineLearningPage.tsx.
//
// Unlike /webinar-aug (lead form → Razorpay) the money action here happens
// INSIDE the Cubemate app: the subscribe CTA points at `/login?next=/pay`, so a
// visitor signs in and lands on the ₹249/mo Pro paywall. The on-page form is
// pure lead capture (WhatsApp group + webinar reminders), not payment.
//
// Differentiating webinar subscribers from regular payers: after subscribing,
// we ask them to email `support@cubemate.ai` with the subject below so Francis
// can match them against the registration list and grant webinar access.

export const ML = {
  // Identifies the registration in webinar_registrations.webinar_slug
  slug: 'machine-learning',

  // Subscription pitch (the real purchase — happens in-app on /pay)
  priceDisplay: '₹249',
  priceCadence: '/month',

  // In-app subscribe CTA. /login?next=/pay works for both logged-out visitors
  // (sign in → PostLoginRedirect honors ?next → /pay) and logged-in ones.
  payUrl: '/login?next=/pay',

  // The free live webinar (free FOR subscribers)
  webinarDateDisplay: 'Friday, Oct 16 · 7:00–9:00 PM IST',
  // Deadline to be in the WhatsApp group so we can send the joining link
  groupJoinBy: 'Wednesday, Oct 14',

  // Support inbox used to flag "I paid, add me to the webinar"
  supportEmail: 'support@cubemate.ai',
  supportSubject: 'Webinar access needed',

  // WhatsApp group invite link for this cohort. Empty string = the confirmation
  // shows an "email/WhatsApp follows" fallback instead of the Join button.
  whatsappLink: 'https://chat.whatsapp.com/IriHtpyzoWqIKXSH5DpJ4M?s=sw&p=i&mlu=4&ilr=4&iam=2',

  // TODO(Francis): Google Ads conversion label (optional). Empty = not fired.
  // Meta pixel Lead/CompleteRegistration events fire regardless.
  googleAdsConversion: '',
};
